var _clipPath, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpoon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 10,
    viewBox: "0 0 40 10",
    width: 40,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-.000214.5h40v9h-40z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m33.5014 9.5c3.5833 0 6.4984-2.01871 6.4984-4.50005s-2.9151-4.49995-6.4984-4.49995c-3.3894 0-6.1795 1.80637-6.4716 4.1018h-4.6771v-.9466h-22.35291362v2.68926h22.35301362v-.94648h4.6771c.2922 2.29554 3.0821 4.10202 6.4715 4.10202zm-12.0118-3.95161h-20.626521v-1.09678h20.626521zm6.3764-.54844c0-2.04217 2.5282-3.70355 5.6355-3.70355s5.6355 1.66138 5.6355 3.70355c0 2.04227-2.5282 3.70375-5.6355 3.70375s-5.6355-1.66148-5.6355-3.70375z",
    fill: "#dcca87"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpoon);
export default __webpack_public_path__ + "static/media/spoon.dff981917cc588a7b58c7380766d3187.svg";
export { ForwardRef as ReactComponent };